import {CompositionPhotoLayer, FinancingCompositionScene} from '@dms/api/shared';

import {randomLowerCaseUUID} from 'shared/web';

import {createCenteredLayerBox} from './createCenteredLayerBox';

// The vehicle photo slot starts large: it is the main subject of a financing promo photo.
export const createPhotoLayer = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>
): CompositionPhotoLayer => ({
  id: randomLowerCaseUUID(),
  type: 'photo',
  ...createCenteredLayerBox(canvas, 0.7, 0.7),
  opacity: 1,
  fit: 'cover',
});
